import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from './virtual-buttons.css';

const simulateKeyPress = key => {
    const event = new KeyboardEvent('keydown', {
        key: key,
        code: key,
        keyCode: key.toUpperCase().charCodeAt(0),
        bubbles: true,
        cancelable: true
    });
    document.dispatchEvent(event);
};

const simulateKeyUp = key => {
    const event = new KeyboardEvent('keyup', {
        key: key,
        code: key,
        keyCode: key.toUpperCase().charCodeAt(0),
        bubbles: true,
        cancelable: true
    });
    document.dispatchEvent(event);
};

const VirtualButtons = () => {
    const [activeKeys, setActiveKeys] = useState(new Set());

    const handleTouchStart = key => {
        setActiveKeys(prevKeys => new Set(prevKeys).add(key));
        simulateKeyPress(key);
    };

    const handleTouchEnd = key => {
        setActiveKeys(prevKeys => {
            const updatedKeys = new Set(prevKeys);
            updatedKeys.delete(key);
            return updatedKeys;
        });
        simulateKeyUp(key);
    };

    return (
        <div className={styles.wrapper}>
            {/* WASD Keys */}
            <div className={styles.wasdKeysWrapper}>
                <div
                    className={`${styles.virtualButton} ${activeKeys.has('w') ? styles.active : ''
                    }`}
                    onTouchStart={() => handleTouchStart('w')}
                    onTouchEnd={() => handleTouchEnd('w')}
                    // onMouseDown={() => handleTouchStart('w')}
                    // onMouseUp={() => handleTouchEnd('w')}
                >
                    W
                </div>
                <div className={styles.horizontalButtons}>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('a') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('a')}
                        onTouchEnd={() => handleTouchEnd('a')}
                        // onMouseDown={() => handleTouchStart('a')}
                        // onMouseUp={() => handleTouchEnd('a')}
                    >
                        A
                    </div>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('s') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('s')}
                        onTouchEnd={() => handleTouchEnd('s')}
                        // onMouseDown={() => handleTouchStart('s')}
                        // onMouseUp={() => handleTouchEnd('s')}
                    >
                        S
                    </div>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('d') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('d')}
                        onTouchEnd={() => handleTouchEnd('d')}
                        // onMouseDown={() => handleTouchStart('d')}
                        // onMouseUp={() => handleTouchEnd('d')}
                    >
                        D
                    </div>
                </div>
            </div>

            {/* Space Button */}
            <div className={styles.spaceButtonWrapper}>
                <div style={{height: 50}} />
                <div
                    className={`${styles.virtualButton} ${activeKeys.has(' ') ? styles.active : ''
                    }`}
                    onTouchStart={() => handleTouchStart(' ')}
                    onTouchEnd={() => handleTouchEnd(' ')}
                    // onMouseDown={() => handleTouchStart(' ')}
                    // onMouseUp={() => handleTouchEnd(' ')}
                    style={{
                        width: 200
                    }}
                >
                    Space
                </div>
            </div>

            <div style={{width: 50}} />

            {/* Arrow Keys */}
            <div className={styles.arrowKeysWrapper}>
                <div
                    className={`${styles.virtualButton} ${activeKeys.has('ArrowUp') ? styles.active : ''
                    }`}
                    onTouchStart={() => handleTouchStart('ArrowUp')}
                    onTouchEnd={() => handleTouchEnd('ArrowUp')}
                    // onMouseDown={() => handleTouchStart('ArrowUp')}
                    // onMouseUp={() => handleTouchEnd('ArrowUp')}
                >
                    ↑
                </div>
                <div className={styles.horizontalButtons}>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('ArrowLeft') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('ArrowLeft')}
                        onTouchEnd={() => handleTouchEnd('ArrowLeft')}
                        // onMouseDown={() => handleTouchStart('ArrowLeft')}
                        // onMouseUp={() => handleTouchEnd('ArrowLeft')}
                    >
                        ←
                    </div>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('ArrowDown') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('ArrowDown')}
                        onTouchEnd={() => handleTouchEnd('ArrowDown')}
                        // onMouseDown={() => handleTouchStart('ArrowDown')}
                        // onMouseUp={() => handleTouchEnd('ArrowDown')}
                    >
                        ↓
                    </div>
                    <div
                        className={`${styles.virtualButton} ${activeKeys.has('ArrowRight') ? styles.active : ''
                        }`}
                        onTouchStart={() => handleTouchStart('ArrowRight')}
                        onTouchEnd={() => handleTouchEnd('ArrowRight')}
                        // onMouseDown={() => handleTouchStart('ArrowRight')}
                        // onMouseUp={() => handleTouchEnd('ArrowRight')}
                    >
                        →
                    </div>
                </div>
            </div>

            {/* Enter Button */}
            <div className={styles.enterButtonWrapper}>
                <div style={{height: 50}} />
                <div
                    className={`${styles.virtualButton} ${activeKeys.has('0') ? styles.active : ''
                    }`}
                    onTouchStart={() => handleTouchStart('0')}
                    onTouchEnd={() => handleTouchEnd('0')}
                    // onMouseDown={() => handleTouchStart('0')}
                    // onMouseUp={() => handleTouchEnd('0')}
                >
                    0
                </div>
            </div>
        </div>
    );
};

VirtualButtons.propTypes = {
    onKeyPress: PropTypes.func
};

export default VirtualButtons;
